import cn from "classnames";

import { CarouselCentered } from "@/components/carouselCentered/carouselCentered.component";

import type { StepsSectionListProps } from "./stepsSection.types";
import { StepsSectionStep } from "./stepsSectionStep.component";

const GRID_COLUMNS: Record<number, string> = {
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
};

export function StepsSectionList({
  steps,
  showIndicator,
  showConnector,
  mobileLayout,
}: StepsSectionListProps) {
  const total = steps.length;

  return (
    <div className="w-full">
      <ol
        data-layout="grid"
        className={cn(
          "hidden w-full gap-8 lg:grid",
          GRID_COLUMNS[total] ?? GRID_COLUMNS[3],
        )}>
        {steps.map((step, index) => (
          <li
            key={step.key}
            data-testid="steps-section-step"
            className="relative">
            <StepsSectionStep
              {...step}
              index={index}
              showIndicator={showIndicator}
              showConnector={showConnector && index < total - 1}
            />
          </li>
        ))}
      </ol>

      {mobileLayout === "carousel" ? (
        <CarouselCentered
          data-layout="carousel"
          role="group"
          aria-label="Steps"
          className="lg:hidden"
          initialSlide={0}
          equalSlideHeights>
          {steps.map((step, index) => (
            <div
              key={step.key}
              role="group"
              aria-label={`Step ${index + 1} of ${total}`}>
              <StepsSectionStep
                {...step}
                index={index}
                showIndicator={showIndicator}
                showConnector={false}
              />
            </div>
          ))}
        </CarouselCentered>
      ) : (
        <ol data-layout="stack" className="flex flex-col gap-10 lg:hidden">
          {steps.map((step, index) => (
            <li key={step.key} data-testid="steps-section-step">
              <StepsSectionStep
                {...step}
                index={index}
                showIndicator={showIndicator}
                showConnector={false}
              />
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
